import styled from "styled-components";
export const Wrapper = styled.div `
  display: grid;
  padding: 20px 40px;
  row-gap: 20px;
`;
